module.exports = __webpack_public_path__ + "static/img/a5.067e9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a5.png
// module id = PtAA
// module chunks = 0